jQuery(document).ready(function ($) {
    $('.section--interactives-map').click(function () {
        var iframe = $(this).find('iframe');

        if (iframe.css('pointer-events').length > 0) {
            iframe.css('pointer-events', 'auto');

            iframe.mouseleave(function () {
                iframe.css('pointer-events', 'none');
            });
        }
    });
});
